import Domains from '../../constants/Domains';

export default {
  ASSET_HUI_IMAGES_URL_BASE: Domains.ASSET_HUI_IMAGES_URL_BASE,
  JOBSTATUSES: {
    NEW: 1,
    ASSIGNED: 2,
    INVITED: 3,
    CLAIMED: 4,
    CLOSED: 5,
    FEEDBACK_COMPLETED: 6,
    CANNOT_ASSIGN: 7,
    DRAFT: 8,
    READY_TO_ASSIGN: 9,
    ENOUGH_CLAIMS: 10,
    AWAITING_INFO: 11,
    HIRED: 12
  },
  HIPAGES_URL: Domains.HIPAGES_URL,
  HIPAGES_HOSTNAME: Domains.HIPAGES_HOSTNAME
};
